var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React from 'react';
import { toJS } from 'mobx';
import { TimePicker } from '@bytebrand/fe-ui-core-autobahn/compat';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
import styles from './OnlineCheckoutModal.styl';
import form from '../OfferRequestModals/formConfigs/RegistrationFormConfig';
import { default as baseContactInfoForm, fields as baseContactInfoFields } from '../OfferRequestModals/formConfigs/UpdateProfileBaseContactInfoConfig';
import { default as additionalAddressForm, fields as additionalAddressFields } from '../OfferRequestModals/formConfigs/UpdateProfileAdditionalAddressConfig';
import { default as contactPageForm } from '../../pages/ContactPage/ContactPageFormConfig';
import { observer } from 'mobx-react';
import withGoogleOptimize from 'components/hoc/WithGoogleOptimize/WithGoogleOptimize';
import { supportPhone } from '@bytebrand/fe-ui-core-autobahn/constants';
import AdditionalAddressForm from './AdditionalAddressForm';
import BaseContactInfoForm from './BaseContactInfoForm';
const DecoratedAdditionalAddressForm = withGoogleOptimize(AdditionalAddressForm);
let OnlineCheckoutModal = class OnlineCheckoutModal extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "isEmpty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (obj) => {
                if (Object.keys(obj).length === 0)
                    return true;
                for (const prop in obj) {
                    if (obj[prop] === null || obj[prop] === '') {
                        return true;
                    }
                }
                return false;
            }
        });
        Object.defineProperty(this, "setFormInit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (formName, formFields, listfields) => {
                formName.init(formFields);
                formName.set('default', { ...listfields });
                formName.each((field) => {
                    if (!field.hasNestedFields) {
                        field.reset(false);
                    }
                });
            }
        });
        Object.defineProperty(this, "onRequestWithoutObligation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (formName) => {
                const { onError, onSuccess } = this.props;
                this.setState({
                    isLoading: true
                });
                formName.submit()
                    .then((form) => {
                    this.setState({
                        isLoading: false
                    });
                    if (form.hasError) {
                        onError();
                    }
                    else {
                        onSuccess();
                    }
                })
                    .catch(() => {
                    this.setState({
                        isLoading: false
                    });
                });
            }
        });
        Object.defineProperty(this, "redirect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { onRedirect } = this.props;
                onRedirect();
            }
        });
        Object.defineProperty(this, "closeModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { onCloseModal } = this.props;
                onCloseModal();
            }
        });
        Object.defineProperty(this, "onHandleTimestampChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (timestamp) => {
                this.setState({ timestamp });
                form.$('timestamp').onChange(timestamp, form.$('timestamp').name);
            }
        });
        Object.defineProperty(this, "isHybridOrElectric", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type) => {
                switch (type) {
                    case 'selector_fuel_electrical':
                        return true;
                    case 'selector_fuel_hybridElectricalPetrol':
                    case 'selector_fuel_hybridElectricalDiesel':
                        return true;
                    default:
                        return false;
                }
            }
        });
        Object.defineProperty(this, "renderBanner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return (React.createElement("div", null,
                    React.createElement("img", { className: styles.axelBanner, src: require('media/images/bestellung_fortsetzen.png'), 
                        // real asset dimensions (not the CSS display size — .axelBanner scales it down
                        // responsively) so the browser reserves the right box before the image loads,
                        // instead of the layer jumping once it arrives.
                        width: 305, height: 253, alt: this.props.t ? this.props.t('CheckoutPage:onlineCheckoutModal.bannerAlt') : 'Bestellung fortsetzen: Fahrzeug jetzt sichern' })));
            }
        });
        this.state = {
            isLoading: false,
            addressAdditional: true,
            baseContactInfo: true,
            timestamp: 0
        };
    }
    componentDidMount() {
        const { addressAdditional, baseContactInfo } = this.props;
        // hotjar.event('ONLINE_CHECKOUT_MODAL');
        if (!this.isEmpty(toJS(baseContactInfo))) {
            this.setState({ baseContactInfo: false });
        }
        else {
            this.setFormInit(baseContactInfoForm, baseContactInfoFields, baseContactInfo);
        }
        if (!this.isEmpty(toJS(addressAdditional))) {
            this.setState({ addressAdditional: false });
        }
        else {
            this.setFormInit(additionalAddressForm, additionalAddressFields, addressAdditional);
        }
    }
    render() {
        const { t, language, hasGoogleOptimize, isAuthorized, tempPassword } = this.props;
        const { isLoading, addressAdditional, baseContactInfo } = this.state;
        return (React.createElement(React.Fragment, null,
            this.renderBanner(),
            React.createElement(Button, { className: `${styles.button} ${styles.buttonCheckout}`, variant: 'filled', onClick: isLoading ? undefined : this.redirect }, t('CheckoutPage:onlineCheckoutModal.redirectBtn')),
            addressAdditional && !baseContactInfo && (React.createElement(DecoratedAdditionalAddressForm, { t: t, isAuthorized: isAuthorized, language: language, redirect: this.redirect, isLoading: isLoading, onHandleTimestampChange: this.onHandleTimestampChange, onRequestWithoutObligation: this.onRequestWithoutObligation, additionalAddressForm: additionalAddressForm, baseContactInfo: baseContactInfo, tempPassword: tempPassword })),
            baseContactInfo && React.createElement(BaseContactInfoForm, { t: t, onRequestWithoutObligation: this.onRequestWithoutObligation, baseContactInfoForm: baseContactInfoForm }),
            !addressAdditional && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: styles.oder }, t('CheckoutPage:onlineCheckoutModal.oder')),
                React.createElement("span", { className: styles.desc }, t('CheckoutPage:onlineCheckoutModal.subtitle1')),
                React.createElement("div", { className: styles.contactItem },
                    React.createElement(IconSVG, { name: 'contactPhone', customDimensions: true, className: styles.contactIcon }),
                    React.createElement("div", { className: styles.contactContent },
                        React.createElement("div", { className: styles.contactTitle }, t('modals:offerRequest.carConsultation')),
                        React.createElement("div", { className: styles.contactText }, supportPhone))),
                hasGoogleOptimize && React.createElement(TimePicker, { onHandleTimestampChange: this.onHandleTimestampChange, lang: language, t: t, className: styles.timePicker, onDayChange: (value) => contactPageForm.$('day').onChange(value), onTimeChange: (value) => contactPageForm.$('time').onChange(value), day: contactPageForm.$('day').value, time: contactPageForm.$('time').value }),
                React.createElement(Button, { className: `${styles.button} ${styles.buttonCheckout} ${styles.backButton}`, variant: 'outlined', onClick: this.closeModal }, t('modals:offerRequest.backToVehicle'))))));
    }
};
OnlineCheckoutModal = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], OnlineCheckoutModal);
export default OnlineCheckoutModal;
